import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { IRsProdukt } from '../../../models/rsprodukt';
import { AntragWeitereFragenComponent } from '../antrag-weitere-fragen/antrag-weitere-fragen.component';
import { IRsPaket } from '../../../models/rspaket';
import { DatenBeratungsprotokollComponent } from '../../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { IRsAntrag } from '../../../models/rsantrag';
import { IRsResult } from '../../../models/rsresult';

@Component({
  selector: 'app-rs-antrag',
  templateUrl: './rs-antrag.component.html',
  styleUrls: ['./rs-antrag.component.scss']
})
export class RsAntragComponent {
  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  datenBeratungsprotokoll: UntypedFormGroup;

  @Input()
  weitereFragen: UntypedFormGroup;

  @Input()
  produkt: IRsProdukt;

  @Input()
  versicherungssumme: string;

  @Input()
  rsResult: IRsResult;

  @Input()
  paket: IRsPaket;

  @Input()
  expertMode: boolean;

  @Output()
  kuendigungRisikenEvent = new EventEmitter<boolean>();

  fuerWenOptions: Map<number, string> =
    new Map([
      [1, 'Für mich'],
      [2, 'Für mich und meine Kinder'],
      [3, 'Für mich, meine/n Ehepartner/in, Lebensgefährten/in und Kinder']
    ]);

  fuerWenOptionsExpert: Map<number, string> =
    new Map([
      [1, 'Versicherungsnehmer/in'],
      [2, 'Versicherungsnehmer/in und ihre/seine Kinder'],
      [3, 'VN, Ehepartner/in, Lebensgefährt/in und Kinder']
    ]);

  @ViewChild(DatenBeratungsprotokollComponent) datenBeratungsprotokollComponent: DatenBeratungsprotokollComponent;
  @ViewChild(AntragWeitereFragenComponent) antragWeitereFragenComponent: AntragWeitereFragenComponent;

  constructor() { }

  setKuendigungRisiken(kuendigungRisiken: boolean) {
    this.kuendigungRisikenEvent.emit(kuendigungRisiken);
  }

  setRsAntrag(rsAntrag: IRsAntrag) {
    this.datenBeratungsprotokollComponent.setOffertBase(rsAntrag);
    this.antragWeitereFragenComponent.setAntrag(rsAntrag);
  }

  getRsAntrag(): IRsAntrag {
    return {
      ...this.antragWeitereFragenComponent.getAntrag(),
      ...this.datenBeratungsprotokollComponent.getOffertBase()
    } as IRsAntrag;
  }
}
